module.exports = __webpack_public_path__ + "img/status_refuse.e333866a.png";